import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { JobOrderLookupComponent } from './job-order-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [JobOrderLookupComponent],
  exports: [JobOrderLookupComponent]
})

export class JobOrderLookupModule { }